import { FC, useEffect, useRef, useState } from 'react';
import styles from './index.module.less';
import { Spin, Switch } from 'antd';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
const minZoom = 9;
const maxZoom = 18;

/**
 * @Description 热力图
 */
const HeatMap:FC<{
  mapIns,
  cityProvinceInfo,
  setActive
}> = ({
  mapIns,
  cityProvinceInfo,
  setActive
}) => {
  const [liveOpen, setLiveOpen] = useState<boolean>(false);
  const [caterOpen, setCaterOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [zoom, setZoom] = useState<number>(0);
  const heatMapRef = useRef<any>(null);// 热力图
  const isOpenRef = useRef<boolean>(false);// 是否打开了热力开关


  const getHeatData = async() => {
    if (!liveOpen && !caterOpen) return;
    if (!cityProvinceInfo?.id) return;
    setLoading(true);

    const type = liveOpen ? 'residential' : 'catering';
    fetch(`https://heat-map.location.pub/city/${type}/${cityProvinceInfo?.id}.json`)
      .then(response => response.json())
      .then(data => {
        const res = data.map((item) => ({
          lng: item?.longitude,
          lat: item?.latitude,
          count: item?.heatCount
        })).sort((a, b) => b.count - a.count);
        heatMapRef.current?.show();
        heatMapRef.current?.setDataSet({ data: res, max: res[Math.floor(res?.length / 100)].count });
        isOpenRef.current = true;
        mapIns?.setZooms([minZoom, maxZoom]);
      })
      .finally(() => {
        setLoading(false);
        // 可缩放
        mapIns.setStatus({
          doubleClickZoom: true,
          zoomEnable: true,
        });
      })
    ;

    // const data = await getHeatMapList({
    //   provinceId: city?.provinceId,
    //   cityId: city?.id,
    //   // 人群类型（1工作人群，2偏爱去餐饮的工作人口, 3餐饮热力, 4居住热力）
    //   crowdType: liveOpen ? 4 : 3,
    // }).finally(() => {
    //   setLoading(false);
    //   // 可缩放
    //   mapIns.setStatus({
    //     doubleClickZoom: true,
    //     zoomEnable: true,
    //   });
    // });

  };
  const handleZoomEnd = () => {
    const zoom = mapIns.getZoom();
    setZoom(Math.floor(zoom));
    if ((zoom < (minZoom + 0.2) || zoom > (maxZoom - 0.2)) && isOpenRef.current) {
      V2Message.error('热力图已开启，请勿继续缩放地图');
      // message.config({ maxCount: 1 });
    }

  };
  const handleHint = () => {
    if (zoom < minZoom) {
      mapIns?.setZoom(12);
    } else if (zoom >= maxZoom) {
      mapIns?.setZoom(14);
    }
    // 不可缩放
    mapIns.setStatus({
      doubleClickZoom: false,
      zoomEnable: false,
    });
    return true;
  };
  useEffect(() => {
    if (!mapIns) return;
    heatMapRef.current = new window.AMap.HeatMap(mapIns, {
      // radius: 50,
      // opacity: [0.75, 0.85],
      // gradient: {
      //   1: '#DE312B',
      //   0.8: '#FC6A17',
      //   0.675: '#FDFF5D',
      //   0.5: '#55DC4C',
      //   0.325: '#7DF8FF',
      //   0.25: '#5771EC',
      //   // 0.875: '#F2A44A',
      //   0: '#DCE2FF'
      // }
      radius: 100,
      opacity: [0, 0.85],
      gradient: {
        1: '#DE312B',
        0.9: '#DE312B',
        0.8: '#FC6A17',
        0.65: '#FDFF5D',
        0.5: '#55DC4C',
        0.4: '#7DF8FF',
        0.3: '#5771EC',
      },

    });
  }, [mapIns]);

  // 互斥
  useEffect(() => {
    if (liveOpen) {
      // 打开居住热力
      setCaterOpen(false);
    }
  }, [liveOpen]);
  // 互斥
  useEffect(() => {
    if (caterOpen) {
      // 打开餐饮热力
      setLiveOpen(false);
    }
  }, [caterOpen]);

  useEffect(() => {
    if (!liveOpen && !caterOpen) {
      heatMapRef.current?.hide();
      isOpenRef.current = false;
      mapIns?.setZooms([3.5, 20]);
    }
  }, [liveOpen, caterOpen]);

  useEffect(() => {
    if (liveOpen) {
      getHeatData();
    }
  }, [liveOpen]);

  useEffect(() => {
    if (caterOpen) {
      getHeatData();
    }
  }, [caterOpen]);

  useEffect(() => {
    getHeatData();
  }, [cityProvinceInfo?.id]);

  // 产品调试所得，在不同级别下，不同热力图半径大小
  useEffect(() => {
    let radius = 2 * zoom;
    switch (zoom) {
      case 9:
        radius = 10;
        break;
      case 10:
        radius = 15;
        break;
      case 11:
        radius = 20;
        break;
      case 12:
        radius = 25;
        break;
      case 13:
        radius = 30;
        break;
      case 14:
        radius = 40;
        break;
      case 15:
        radius = 60;
        break;
      case 16:
        radius = 80;
        break;
      case 17:
        radius = 150;
        break;
        // case 18:
        //   radius = 350;
        //   break;

      default:
        break;
    }
    heatMapRef.current?.setOptions({
      radius
    });
  }, [zoom]);

  useEffect(() => {
    if (!mapIns) return;
    mapIns.on('zoomend', handleZoomEnd);
    return () => {
      mapIns.off('zoomend', handleZoomEnd);
    };
  }, [mapIns]);

  useEffect(() => {
    return () => {
      heatMapRef.current?.hide();
    };
  }, []);

  return <Spin spinning={loading}>
    <div
      onMouseEnter={() => setActive('')}
      className={styles.card}>
      <span className='mr-16'>居住热力</span>
      <Switch
        className={styles.switch}
        size='small'
        checked={liveOpen}
        onChange={() => {
          // 未打开点击，才说明是点开的操作
          if (!liveOpen) {
            if (!handleHint()) return;
          }
          setLiveOpen((state) => !state);
          setCaterOpen(false);
        }}/>
    </div>
    <div className={styles.card}>
      <span className='mr-16'>餐饮热力</span>
      <Switch
        className={styles.switch}
        size='small'
        checked={caterOpen}
        onChange={() => {
          // 未打开点击，才说明是点开的操作
          if (!caterOpen) {
            if (!handleHint()) return;
          }
          setLiveOpen(false);
          setCaterOpen((state) => !state);
        }}
      />
    </div>
  </Spin>;
};
export default HeatMap;
